import type { OrderResponseItemType } from './orderResponseItemType';
import type { OrderResponseOrderType } from './orderResponseOrderType';
import type { OrderResponseStatus } from './orderResponseStatus';

export interface OrderResponse {
  /** 주문 금액 */
  amount: number;
  /** 빌링키 */
  billingKey?: string;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 이름 */
  buyerName?: string;
  /** 생성일시 */
  createdAt: string;
  /** 주문 ID */
  id: string;
  /** 상품 타입 */
  itemType?: OrderResponseItemType;
  /** 주문 타입 */
  orderType?: OrderResponseOrderType;
  /** 결제일시 */
  paymentDate?: string;
  /** 결제 방법 */
  paymentMethod?: string;
  /** 상품 코드 */
  productCode?: string;
  /** 상품명 */
  productName?: string;
  /** 플랜 코드 */
  productPlanCode?: string;
  /** 주문 상태 */
  status: OrderResponseStatus;
  /** 거래 ID */
  tid?: string;
  /** 수정일시 */
  updatedAt?: string;
  /** 사용자 ID */
  userId?: string;
}
